<template>
  <div id="expertReportDetailsView">
    <div v-if="$route.name === 'expertreport'">
      <h1>{{ $t('privatePage.expert_report_header') }}</h1>
      <b-tabs>
        <b-tab :title="$t('privatePage.details')" active>
          <expert-report-details-editor v-on:onSubmit="onSubmitReportDetails"
                                          v-on:onDeleteReport="onDeleteReport"
                                          v-on:onAddTranslation="onAddTranslation"
                                          v-on:onDeleteTranslation="onDeleteTranslation"
                                          :currentReport="currentReport"
                                          :languages="languages"
                                          :reportOptions="reportOptions"/>
        </b-tab>
        <b-tab :title="$t('privatePage.expert_report_content_header')">
          <expert-report-content-editor :currentReport="currentReport"
                          :languages="languages"
                          v-on:onSubmit="onSubmitReportDetails"
                          v-on:onGeneratePdf="onGeneratePdf"
                          v-on:onGenerateMultiPdf="onGenerateMultiPdf"/>
        </b-tab>
      </b-tabs>
    </div>
    <div v-else>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ExpertReportDetailsEditor from '../../components/expertreports/expertreportdetailseditor'
import ExpertReportContentEditor from '../../components/expertreports/expertreportcontenteditor'
import misc from '../../js/helpers/misc'

function createTranslation(languageId) {
  return {
    id: '',
    languageId: languageId,
    items: []
  }
}

export default {
  name: 'expert-report-details-view',
  components: {
    ExpertReportDetailsEditor,
    ExpertReportContentEditor
  },
  data() {
    return {
      reportOptions: {
        testMethods: []
      }
    }
  },
  computed: {
    ...mapGetters(['selectedCulture', 'languages', 'userId']),
    ...mapGetters('expertReportsModule', ['currentReport']),
    ...mapGetters('testMethodsModule', ['activeStandardTestMethods'])
  },
  methods: {
    ...mapActions({
      showSuccessMessage: 'showSuccessMessage',
      showErrorMessage: 'showErrorMessage'
    }),
    ...mapActions('expertReportsModule', [
      'getAllReports',
      'getReport',
      'saveReportDetails',
      'deleteReport',
      'deleteTranslation'
    ]),
    ...mapActions('testMethodsModule', {
      getTestMethods: 'getActiveStandardTestMethods'
    }),
    ...mapActions('testSuitesModule', {
      generatePdf: 'generatePdf',
      generateMultiPdf: 'generateMultiPdf'
    }),
    onAddTranslation: function(languageId) {
      if (this.currentReport.translations === undefined) {
        this.currentReport.translations = []
      }

      let translationIndex = misc.getIndexInCollection(
        'languageId',
        languageId,
        this.currentReport.translations
      )

      if (translationIndex === -1) {
        this.currentReport.translations.push(createTranslation(languageId))
      }
    },
    onDeleteTranslation: function(translation) {
      if (
        window.confirm(
          this.$t('privatePage.translationDelete_confirmation')
        )
      ) {
        this.deleteTranslation(translation)
          .then(() => {
            if (this.currentReport.id) {
              this.getReport({
                reportId: this.currentReport.id
              })
                .then(() => {
                  this.showSuccessMessage(
                    this.$t('privatePage.translationDelete_message')
                  )
                })
                .catch(error => {
                  this.showErrorMessage(error)
                })
            } else {
              this.showSuccessMessage(this.deleteTranslationMessage)
            }
          })
          .catch(error => {
            this.showErrorMessage(error)
          })
      }
    },
    onSubmitReportDetails: function() {
      this.saveReportDetails(this.currentReport).then(() => {
        this.getAllReports().then(() => {
          this.showSuccessMessage(this.$t('save_ok_feedback'))
        })
      })
    },
    onDeleteReport: function() {
      if (
        window.confirm(
          this.$t('privatePage.expert_report_delete_confirmation')
        )
      ) {
        this.deleteReport(this.currentReport)
          .then(() => {
            window.alert(
              this.$t('privatePage.expert_report_delete_message')
            )
            this.$router.go(-1)
          })
          .catch(error => {
            this.showErrorMessage(error)
          })
      }
    },
    onGeneratePdf(pdfSettings) {
      pdfSettings.userId = this.userId
      pdfSettings.isPreviewMode = true
      pdfSettings.isExpertReport = true
      this.generatePdf(pdfSettings)
    }
  },
  created() {
    if (!this.currentReport.id) {
      if (
        this.currentReport.translations === undefined ||
        (this.currentReport.translations !== undefined &&
          this.currentReport.translations.length === 0)
      ) {
        this.onAddTranslation(this.selectedCulture.languageId)
      }
    }
    this.getTestMethods()
      .then(data => {
        this.activeStandardTestMethods.forEach(tm => {
          let testMethod = {
            id: tm.id,
            name: tm.name
          }
          this.reportOptions.testMethods.push(testMethod)
        })
      })
      .catch(error => {
        this.showErrorMessage(error)
      })
  }
}
</script>
